export function formatDateSend(today){
    today = new Date(today);
   var year = today.getFullYear();
   var month = ('0' + (today.getMonth() + 1)).slice(-2);
   var day = ('0' + today.getDate()).slice(-2);
   var formattedDate = year + '-' + month + '-' + day;
   return formattedDate
}